module.exports = __webpack_public_path__ + "img/2.c6e329f2.jpg";